import { ExportFormPage } from './ExportFormPage';

// Titles follow the sidebar menu; `path` is the backend `/export/<path>/` family.

export const ExportFranchiseServicesPage = () => (
  <ExportFormPage title="Экспорт франшизных СТО" path="franchise-services" hasCountrySelect />
);

export const ExportBidsPage = () => <ExportFormPage title="Экспорт заявок" path="bids" hasCountrySelect />;

export const ExportRejectedBidsPage = () => (
  <ExportFormPage title="Экспорт отменённых заявок" path="rejected-bids" />
);

export const ExportBillingPage = () => <ExportFormPage title="Экспорт пополнений" path="billing-payment" />;

export const ExportServicePage = () => <ExportFormPage title="Экспорт сервисов" path="service-payment" />;

export const ExportCartsPage = () => <ExportFormPage title="Экспорт корзин запчастей" path="carts" />;

export const ExportMarketingPaymentPage = () => (
  <ExportFormPage title="Экспорт платежей, маркетинг" path="marketing-payment" />
);

export const ExportLoyaltyPage = () => <ExportFormPage title="Экспорт по партнеркам" path="billing-loyalty" />;

export const ExportLoyaltyBidsPage = () => (
  <ExportFormPage
    title="Экспорт лояльности"
    path="promo-codes"
    downloadFileName="loyalty-export.json"
    hasLoyaltyFilters
  />
);

export const ExportPartOrdersPage = () => (
  <ExportFormPage title="Экспорт заказов запчастей" path="part-orders" />
);

export const ExportUsersPage = () => (
  <ExportFormPage title="Экспорт пользователей" path="users" hasCountrySelect />
);
